__turbopack_context__.v({
  "detail": "Detail-module__yMy32a__detail",
  "largeDetail": "Detail-module__yMy32a__largeDetail",
  "largeDetailBody": "Detail-module__yMy32a__largeDetailBody",
  "largeDetailFooterContainer": "Detail-module__yMy32a__largeDetailFooterContainer",
  "largeDetailIcon": "Detail-module__yMy32a__largeDetailIcon",
  "largeDetailIconContainer": "Detail-module__yMy32a__largeDetailIconContainer",
  "largeDetailTitle": "Detail-module__yMy32a__largeDetailTitle",
  "mediumDetail": "Detail-module__yMy32a__mediumDetail",
  "mediumDetailBody": "Detail-module__yMy32a__mediumDetailBody",
  "mediumDetailIcon": "Detail-module__yMy32a__mediumDetailIcon",
  "mediumDetailIconContainer": "Detail-module__yMy32a__mediumDetailIconContainer",
  "mediumDetailTitle": "Detail-module__yMy32a__mediumDetailTitle",
  "smallDetail": "Detail-module__yMy32a__smallDetail",
  "smallDetailBody": "Detail-module__yMy32a__smallDetailBody",
  "smallDetailIcon": "Detail-module__yMy32a__smallDetailIcon",
  "smallDetailIconContainer": "Detail-module__yMy32a__smallDetailIconContainer",
  "smallDetailTitle": "Detail-module__yMy32a__smallDetailTitle",
});
